module.exports = __webpack_public_path__ + "static/merch6Back-0126849c8ac4df65f2ccd765671ce0dc.png";